import { Routes, Route, Navigate } from 'react-router-dom'
import Connections from './pages/Connections'
import Composer from './pages/Composer'
import Posts from './pages/Posts'
import Inbox from './pages/Inbox'
import Advertising from './pages/Advertising'
import Followers from './pages/Followers'
import Analytics from './pages/Analytics'
import Competitors from './pages/Competitors'
import Listening from './pages/Listening'
import Reports from './pages/Reports'
import WebhookEvents from './pages/WebhookEvents'
import AutoLogin from './pages/AutoLogin'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'
import { ToastProvider } from './components/Toast'
import LoginPage from './pages/LoginPage'
import { AuthProvider, RequireAuth } from './components/AuthProvider'
import { WorkspaceProvider } from './hooks/useWorkspaceContext'

function App() {
  return (
    <div className="smm-app theme-crm-light">
      <ErrorBoundary>
      <ToastProvider>
      <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auto-login" element={<AutoLogin />} />
        <Route element={<RequireAuth />}>
          <Route element={<WorkspaceProvider><Layout /></WorkspaceProvider>}>
            <Route path="/" element={<Navigate to="/connections" replace />} />
            <Route path="/connections" element={<Connections />} />
            <Route path="/composer" element={<Composer />} />
            <Route path="/posts" element={<Posts />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/advertising" element={<Advertising />} />
            <Route path="/followers" element={<Followers />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/competitors" element={<Competitors />} />
            <Route path="/listening" element={<Listening />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/webhook-events" element={<WebhookEvents />} />
          </Route>
        </Route>
      </Routes>
      </AuthProvider>
      </ToastProvider>
      </ErrorBoundary>
    </div>
  )
}

export default App
